import { Fieldset } from '@antimatterhq/ui/components/fieldset';
import { DatasourceReviewValue } from '../value/DatasourceReviewValue';
import { DatasourceUpgradeFieldStatus } from '@/lib/datasource/upgrade/datasourceUpgrade.types';

export const FiltersReview = ({
  filter = '',
  postFilter = '',
  filterStatus,
  postFilterStatus,
}: {
  filter?: string;
  postFilter?: string;
  filterStatus?: DatasourceUpgradeFieldStatus;
  postFilterStatus?: DatasourceUpgradeFieldStatus;
}) => {
  return (
    <>
      <div>
        <Fieldset.Field>
          <Fieldset.Label>Filters</Fieldset.Label>
        </Fieldset.Field>
        <Fieldset.List>
          <Fieldset.Field>
            <Fieldset.Label>
              <span className="whitespace-nowrap">Pre-Processing Filter:</span>
            </Fieldset.Label>
            <Fieldset.Value>
              <DatasourceReviewValue status={filterStatus}>
                <div
                  className="max-w-[600px] truncate"
                  data-testid="review-filter-expression"
                >
                  {filter || <span className="italic">[none]</span>}
                </div>
              </DatasourceReviewValue>
            </Fieldset.Value>
          </Fieldset.Field>
          <Fieldset.Field>
            <Fieldset.Label>
              <span className="whitespace-nowrap">Post-Processing Filter:</span>
            </Fieldset.Label>
            <Fieldset.Value>
              <DatasourceReviewValue status={postFilterStatus}>
                <div
                  className="max-w-[600px] truncate"
                  data-testid="review-post-filter-expression"
                >
                  {postFilter || <span className="italic">[none]</span>}
                </div>
              </DatasourceReviewValue>
            </Fieldset.Value>
          </Fieldset.Field>
        </Fieldset.List>
      </div>
    </>
  );
};
